export default __webpack_public_path__ + "static/media/absolute~blqSPwEe.bf13742c.svg";